import router from "../router";
import Vue from "vue";
import store from "../state/store";

export default function setup(axios) {
  /**
   * Helper: toggle global loading state based on request config.
   * Only applies when config.withLoading is truthy.
   */
  const setLoadingFromConfig = (config, status) => {
    if (config && config.withLoading) {
      store.dispatch("loading/changeLoading", status);
    }
  };

  axios.interceptors.request.use(
    function (config) {
      const token = localStorage.getItem("authToken");
      config.headers.Authorization = "Bearer " + token;

      // Enable global loading if requested for this call
      setLoadingFromConfig(config, true);

      return config;
    },
    function (error) {
      // In case of request error, make sure loading is turned off
      if (error && error.config) {
        setLoadingFromConfig(error.config, false);
      }
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => {
      // Turn off loading when response arrives
      setLoadingFromConfig(response.config, false);
      return Promise.resolve(response);
    },
    (error) => {
      // Defensive: error.response can be undefined on network/CORS failures
      const status =
        error && error.response && error.response.status
          ? error.response.status
          : null;

      // Always clear loading for failed requests as well
      if (error && (error.config || error.response?.config)) {
        const cfg = error.config || error.response.config;
        setLoadingFromConfig(cfg, false);
      }

      if (status === 401) {
        router.push({ name: "logout" });
      } else if (status === 422) {
        const data = error?.response?.data;
        const validationErrors = data?.extra[0]?.errors;

        let errorList = "";
        Object.entries(validationErrors).forEach((obj) => {
          if (obj[1][0]) {
            errorList += `<li>${obj[1][0]}</li>`;
          }
        });

        Vue.swal({
          position: "center",
          icon: "warning",
          title:
            data?.errors && data.errors[0]
              ? data.errors[0].title
              : "Validation error",
          showConfirmButton: false,
          html: `<ul>${errorList}</ul>`,
          timer: 20000,
        });
      } else if (status === null) {
        // Network error / CORS / no response received
        console.error(
          "Network or CORS error - no response received from server",
          error
        );
        Vue.swal({
          position: "center",
          icon: "error",
          title: "Error de red",
          html:
            "No se ha recibido respuesta del servidor. Comprueba la conexión o la configuración CORS.",
          showConfirmButton: true,
        });
      } else {
        let errorData = error.response.data;

        const errorTitle =
          errorData?.errors[0]?.title ||
          "Ha ocurrido un error en el servidor";

        Vue.swal({
          position: "top-end",
          icon: "warning",
          title: errorTitle,
          showConfirmButton: false,
          timer: 20000,
        });
      }

      return Promise.reject(error);
    }
  );
}
